<div *ngIf="processoDocumento != undefined">
  <p-dialog
    header="{{processoDocumento.id}} - {{processoDocumento.nome}}"
    [(visible)]="visivel"
    [contentStyle]="{'overflow':'visible'}"
    modal="true"
    closeOnEscape="true"
    maximizable="true"
    appendTo="body">
    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-6">
          <div class="texto">
            <div [innerText]="texto"></div>
          </div>
        </div>
        <div class="p-col-6">
          <app-arquivo-visualizador [arquivo]="original"></app-arquivo-visualizador>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
